import Tippy from "@tippyjs/react"

export const RunMessageTooltip = () => {
    return(
        <Tippy
            content={
            <div className="text-sm text-left max-w-sm">
                <p className="mb-2">Messages are used to communicate issues or delays that happen during the run.</p>

                <p className="mb-2">They will be sent to the emails and/or phones of users that set up POI notifications for the run.</p>

                <p>To prevent inaccurate POI notifications from being sent, supervisors may pause notifications for a period of time.</p>
            </div>
            }
            interactive
            delay={[200, 0]}
            placement="bottom"
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 ml-2 cursor-help"
                aria-label="What are messages used for?"
            />
        </Tippy>
    )
}